import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "../i18n";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("vg-lang") || "en");

  useEffect(() => {
    localStorage.setItem("vg-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, s: STRINGS[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};
